export default __webpack_public_path__ + "static/media/money-back@3x.e1b1c9ce.png";